import { render, staticRenderFns } from "./FrequentQuestions.vue?vue&type=template&id=3e00ef02&"
import script from "./FrequentQuestions.vue?vue&type=script&lang=js&"
export * from "./FrequentQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports